import type { ComponentProps } from "react";
import { useCustomerContacts } from "@/hooks/use-customer-contacts";
import { useLeadContacts } from "@/hooks/use-lead-contacts";
import BookMeetingDialog from "./BookMeetingDialog";

interface BookMeetingFromRecordProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Kunden møtet gjelder, eller null for en prosess på et lead. */
  customerId: string | null;
  leadId?: string | null;
  name: string;
  opportunityId?: string | null;
  topic?: string | null;
  defaultContactId?: string | null;
  defaultInternalNote?: string | null;
  onBooked?: ComponentProps<typeof BookMeetingDialog>["onBooked"];
}

/** Bookingdialogen for en kunde eller et lead som laster kontaktpersonene selv (køen, pipen og kundekortet). */
export default function BookMeetingFromRecord({
  open,
  onOpenChange,
  customerId,
  leadId,
  name,
  opportunityId,
  topic,
  defaultContactId,
  defaultInternalNote,
  onBooked,
}: BookMeetingFromRecordProps) {
  const customerContacts = useCustomerContacts(open && customerId ? customerId : undefined);
  const leadContacts = useLeadContacts(open && !customerId ? leadId : undefined);
  const raw = (customerId ? customerContacts.data : leadContacts.data) ?? [];
  const contacts = raw.filter((c) => c.is_active && !c.anonymized_at);
  if (!customerId && !leadId) return null;
  return (
    <BookMeetingDialog
      open={open}
      onOpenChange={onOpenChange}
      subject={customerId ? { kind: "customer", id: customerId, name } : { kind: "lead", id: leadId!, name }}
      contacts={contacts}
      opportunityId={opportunityId}
      defaultContactId={defaultContactId}
      defaultTopic={topic}
      defaultInternalNote={defaultInternalNote}
      onBooked={onBooked}
    />
  );
}
